import React from "react";
import "./Loader.css";

export const Loader = () => {
  return <p className="loader"></p>;
};
